@if ((isLoaded | async) && (hasErrorState || getZeroStateStatus())) {
  <section class="data-source-zero-state">
    @if (hasErrorState) {
      @switch (errorCode) {
        @case (0) {
          <ngx-zero-state class="error-connection">
            <div zero-state-title translate="folder-error-zero-states_internet-connection-lost-title"></div>
            <div zero-state-subtext translate="folder-error-zero-states_internet-connection-lost-subtext"></div>
            <div zero-state-graphic-bottom>
              <img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="internet connection error">
            </div>
          </ngx-zero-state>
        }
        @case (404) {
          <ngx-zero-state class="error-not-found">
            <div zero-state-title translate="folder-error-zero-states_folder-not-found-title"></div>
            <div zero-state-subtext translate="folder-error-zero-states_folder-not-found-subtext"></div>
            <div zero-state-graphic-bottom>
              <img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="not found">
            </div>
          </ngx-zero-state>
        }
        @case (403) {
          <ngx-zero-state class="error-forbidden">
            <div zero-state-title translate="folder-error-zero-states_folder-not-found-title"></div>
            <div zero-state-subtext translate="folder-error-zero-states_folder-forbidden-subtext"></div>
            <div zero-state-graphic-bottom>
              <img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="forbidden">
            </div>
          </ngx-zero-state>
        }
        <!--Unexpected Error-->
        @default {
          <ngx-zero-state class="error-unexpected">
            <div zero-state-title translate="folder-error-zero-states_unexpected-title"></div>
            <div zero-state-subtext translate="folder-error-zero-states_unexpected-subtext"></div>
            <div zero-state-graphic-bottom>
              <img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="unexpected error">
            </div>
          </ngx-zero-state>
        }
      }
    }
    @if (!hasErrorState) {
      @switch (getZeroStateStatus()) {
        @case (zeroStates.DEACTIVATED_ROLE) {
          <ngx-zero-state
            class="zero-state-deactivated-role">
            <div zero-state-title translate="group-view_zero-state-blocked-from-course-title"></div>
            <div zero-state-subtext translate="group-view_zero-state-blocked-from-course-subtext"></div>
            <div zero-state-body>
              <a href="https://support.echo360.com/hc/en-us/articles/38459181689485-Student-FAQs" target="_blank" rel="noopener noreferrer" class="primary-btn manage-btn" translate="group-view_zero-state-blocked-from-course-link"></a>
            </div>
            <div zero-state-graphic-bottom>
              <img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="Deactivated Role">
            </div>
          </ngx-zero-state>
        }
        @case (zeroStates.MAX_SEAT_REACHED) {
          <ngx-zero-state
            class="zero-state-maximum-seats-reached"
            >
            <div zero-state-title translate="group-view_zero-state-maximum-seats-reached-title"></div>
            <div zero-state-subtext translate="group-view_zero-state-maximum-seats-reached-subtext"></div>
            <div zero-state-graphic-bottom>
              <img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="Max Seats Reached">
            </div>
          </ngx-zero-state>
        }
        @case (zeroStates.NO_ELIGIBLE_BILLING) {
          <ngx-zero-state
            class="zero-state-no-eligible-billing"
            >
            <div zero-state-title><span translate="group-view_zero-state-no-eligible-billing-title"></span></div>
            <div zero-state-subtext>
              @if (group.hasInstructorRole(true)) {
                <span translate="group-view_zero-state-no-eligible-billing-subtext-instructor"></span>
              }
              @if (!group.hasInstructorRole(true)) {
                <span translate="group-view_zero-state-no-eligible-billing-subtext-student"></span>
              }
            </div>
            <div zero-state-body>
              @if (group.hasInstructorRole(true)) {
                <button
                  class="btn primary-btn manage-btn eligible-btn"
                  translate="manage-folder_button-title"
                  (click)="openGroupSettings()">
                </button>
              }
            </div>
            <div zero-state-graphic-bottom>
              <img class="zero-state-image" class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="No longer on a license">
            </div>
          </ngx-zero-state>
        }
        @case (zeroStates.COURSE_PAYMENT_WALL) {
          <ngx-course-payment-wall
            (onCredit)="onCredit()"
            (onPay)="onPay($event)">
          </ngx-course-payment-wall>
        }
      }
    }
  </section>
}

@if ((isLoaded | async) !== true) {
  <section class="data-source-zero-state loading">
    <loading></loading>
  </section>
}
